import url from './url.js'
import axios from './axios.conf.js'
import * as mock from './mock'

let ISMOCK
ISMOCK = false
// ISMOCK = true
let hostName = window.location.hostname
if (hostName === 'm.jr.jd.com'|| hostName === 'minner.jr.jd.com') {
  ISMOCK = false
}

// 判断是否可以参与接口
export function judgeIsCanJoin (params) {
  if (ISMOCK) {
    return Promise.resolve(mock.initInfo)
  }

  return axios.post(url.initInfo, params).then(res => {
    console.log('axios_initInfo:::', res)
    return res
  })
}

//获取参与并激活列表接口(奖券)
export function myShareInfo (params) {
  if (ISMOCK) {
    return Promise.resolve(mock.myShareInfo)
  }

  return axios.post(url.myShareInfo, params).then(res => {
    // if (typeof res === 'string') {
    //   res = JSON.parse(res)
    // }

    return res
  })
}

//参与游戏接口(领取奖励/分享弹窗)
export function takeReward1 (params) {
  if (ISMOCK) {
    return Promise.resolve(mock.takeReward1)
  }

  return axios.post(url.takeReward1, params).then(res => {
    // if (typeof res === 'string') {
    //   res = JSON.parse(res)
    // }

    return res
  })
}

//判断是否是新人接口
export function isShareRoleInfo (params) {
  if (ISMOCK) {
    return Promise.resolve(mock.isShareRoleInfo)
  }

  return axios.post(url.isShareRoleInfo, params).then(res => {
    // if (typeof res === 'string') {
    //   res = JSON.parse(res)
    // }

    return res
  })
}

//分享增加参与机会
export function addTimes (params) {
  if (ISMOCK) {
    return Promise.resolve(mock.addTimes)
  }

  return axios.post(url.addTimes, params).then(res => {
    // if (typeof res === 'string') {
    //   res = JSON.parse(res)
    // }

    return res
  })
}

//是否已分享或已设置提醒
export function isFinishedInfo (params) {
  if (ISMOCK) {
    return Promise.resolve(mock.isFinishedInfo)
  }

  return axios.post(url.isFinishedInfo, params).then(res => {
    // if (typeof res === 'string') {
    //   res = JSON.parse(res)
    // }

    return res
  })
}
